import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Col } from 'react-bootstrap';
import profile from '../images/profile.png'
import "../../Pages/CommonStyle.css"
import { getReadableDateDDMMYYYY, getReadableDateYYYYMMDD, getReadableTime } from "../../utils/utils";

import TextField from '@mui/material/TextField';
import axios from 'axios';

import { toast } from 'react-toastify';
import ic_calendar from "../../images/ic_calendar_invite.svg"
import ic_time from "../../images/ic_time_invite.svg"
import ic_dropdown_invite from "../../images/ic_dropdown_invite.svg"

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import { base_url_image_view_api } from '../../utils/ImageViewingAPI';
import { base_url } from '../../utils/AxiosConfig';


const ShowMoreEventsModal = ({ showMoreModal, closeShowMoreEventsModal, allEventsArray , eventOriginalArray}) => {



    const [currentClickedEvent, setCurrentClickedEvent] = useState("")
    const [isCallingEmployeeAPI, setIsCallingEmployeeAPI] = useState(false);
    const [checked, setChecked] = useState([]);

    const handleToggle = (eventIdFromClick, value, imagepathFromClick, nameFromClick, deptFromClick) => () => {

        console.log("eventId checked ", eventIdFromClick, value, imagepathFromClick)

        // no need for below code it is for multiple selection , we need only one person
        // so direct replacement of checked to state
        // const currentIndex = checked?.indexOf(value);
        // const newChecked = [...checked];

        // if (currentIndex === -1) {
        //     newChecked.push(value);
        // } else {
        //     newChecked.splice(currentIndex, 1);
        // }

        let newObject = {
            eventId: eventIdFromClick,
            invited_member_id: value,
            invited_member_imagepath: imagepathFromClick,
            invited_member_name: nameFromClick,
            invited_member_department: deptFromClick
        }

        setChecked([newObject]);


    };

    let timeOutEmployeeTyping = null;

    let portNumber = localStorage.getItem('BondTimeportNoData');

    
    const [toggleEmployeeList, setToggleEmployeeList] = useState(false)
    const [employeeListArray, setEmployeeListArray] = useState(null)

    console.log("allEventsArray", allEventsArray)

    const callEmployeeList = () => {

        const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
        }

        console.log("calling employee list")

        // setIsCallingEmployeeAPI(true)

        let apiUrLEmployeeLsit = `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        axios.get(apiUrLEmployeeLsit).then((res) => {

            setEmployeeListArray(res.data)

            // setIsCallingEmployeeAPI(false)

        }).catch((err) => {
            // setIsCallingEmployeeAPI(false)
        })
    }

    const getProfilePic = (dataFromImagePath) => {

        if (dataFromImagePath) {
            // Extract the file name and extension from the last entry
            const filePath = dataFromImagePath.replace(/\\/g, "/");
            const fileName = filePath.split('/').pop(); // Extracts the last part (filename with extension)

            // Construct the full URL for the image
            return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
        }
    }

    const handleChange = (e) => {

        if (e.target?.length > 0) {
            setToggleEmployeeList(true)
        }

        console.log(" typed ")

        if (timeOutEmployeeTyping) {

            clearTimeout(timeOutEmployeeTyping)

        }
        timeOutEmployeeTyping = setTimeout(() => {
            console.log(" e ", e.target.value)

        }, 500)



    }


    const clickedonAddMembers = (eventIdFromArrowClick) => {

        console.log("clicked on Add members event id ", eventIdFromArrowClick)

        setToggleEmployeeList(prev => !prev)
        setCurrentClickedEvent(eventIdFromArrowClick)

    }

    useEffect(() => {

        console.log("toggleEmployeeList", toggleEmployeeList)

        if (toggleEmployeeList) {

            callEmployeeList()
        }
    }, [toggleEmployeeList])



    const callInvitationAPI = (itemFromSendButton, empIdFromSendButton, empName, empDepartment) => {

        console.log("itemFromSendButton ",itemFromSendButton)

       let filteredEvent =  eventOriginalArray.filter((eventOrigy)=> eventOrigy.event_id == itemFromSendButton.eventId )

        const initialObject =
        {
            cmpcode: "${companyCode}",
            mode: "EDIT",
            event_id: itemFromSendButton.eventId,
            event_name: filteredEvent[0].event_name,
            event_scheduledon: filteredEvent[0].event_scheduledon,
            event_owner_id: empIdFromSendButton,
            evnt_ownder_name: empName,
            event_ownder_dept: empDepartment,
            created_on: filteredEvent[0].created_on,
            evnt_creator_name: filteredEvent[0].event_creator_name, //FromLocal login
            event_creator_id: filteredEvent[0].event_creator_id, // from local login
            devicetoken_employee: filteredEvent[0].DEVICETOKEN_employee,
            devicetoken_admin: filteredEvent[0].DEVICETOKEN_admin,
            event_status: filteredEvent[0].event_status

        }

        console.log("object to send to api", initialObject)

        const postBody = JSON.stringify([initialObject])

        let apiUrl = `${base_url}/api/CRMEvents`

        axios.post(apiUrl, postBody, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            if (res.status === 200) {
                toast.success('Event Saved!')
            }
        }).catch((err) => {
            console.log("err", err)
        })

    }

    return (
        <Modal show={showMoreModal} onHide={closeShowMoreEventsModal} centered>
            <Modal.Header closeButton>
                <p>All Events</p>
            </Modal.Header>
            <Modal.Body >

                <div>

                    {
                        allEventsArray?.map((item) => {
                            return (
                                <div className='request_grid_item mt-2'>
                                    <p className='py-2'>{item.title}</p>

                                    <p className='d-flex justify-content-between '>
                                        <div className='d-flex'>
                                            <span className='request_grid_item' style={{ backgroundColor: "#ededed", padding: "14px" }}>
                                                <span className='d-flex'>
                                                    <img src={ic_time} style={{ width: "40px" }} />
                                                    <p className='ms-2' style={{ fontSize: "14px" }}>Meeting <br /> Time</p>
                                                </span>
                                                <span className='mt-2'>{getReadableTime(item.start)}</span>

                                            </span>

                                            <span className='request_grid_item ms-2' style={{ backgroundColor: "#ededed", padding: "14px" }}>
                                                <span className='d-flex'>
                                                    <img src={ic_calendar} style={{ width: "40px" }} />
                                                    <p className='ms-2' style={{ fontSize: "14px" }}>Meeting <br /> Date</p>
                                                </span>
                                                <span className='mt-2'>{getReadableDateDDMMYYYY(item.start)}</span>

                                            </span>
                                        </div>

                                        <div style={{ display: "flex", width: "100%", justifyContent: "end", alignItems: "center" }}>

                                            {
                                                checked?.some((sommyAvatar => sommyAvatar.eventId == item.eventId)) &&

                                                <span className='d-flex'>
                                                    {

                                                        <Avatar
                                                            src={getProfilePic(checked[0]?.invited_member_imagepath)}
                                                        />
                                                    }

                                                    <button className='btn common-button  text-center' onClick={() => callInvitationAPI(item, checked[0]?.invited_member_id, checked[0]?.invited_member_name, checked[0]?.invited_member_department)} >Send Invite</button>
                                                </span>
                                            }


                                        </div>

                                    </p>


                                    <span className='w-100 d-flex'>

                                        <TextField
                                            style={{ width: "100%" }}
                                            label="Search for members"
                                            variant="standard"
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                        />
                                        <img
                                            src={ic_dropdown_invite}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => clickedonAddMembers(item.eventId)} />

                                    </span>



                                    {
                                        toggleEmployeeList && item.eventId == currentClickedEvent ?

                                            isCallingEmployeeAPI ?

                                                <CircularProgress />
                                                :
                                                <List dense sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper' }}>
                                                    {
                                                        employeeListArray?.map((value) => {
                                                            const labelId = `checkbox-list-secondary-label-${value}`;
                                                            return (

                                                                <ListItem
                                                                    key={value}
                                                                    secondaryAction={
                                                                        <Checkbox
                                                                            edge="end"
                                                                            onChange={handleToggle(item.eventId, value.EmpId, value.imagepath, value.Name,value.Department)}

                                                                            checked={checked?.filter(itemChecky => itemChecky.eventId == item.eventId)?.some(sommy => sommy.invited_member_id == value.EmpId)}
                                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                                        />
                                                                    }
                                                                    disablePadding
                                                                >
                                                                    <ListItemButton>
                                                                        <ListItemAvatar>
                                                                            <Avatar
                                                                                src={getProfilePic(value.imagepath)}
                                                                            />
                                                                        </ListItemAvatar>
                                                                        <ListItemText id={labelId} primary={value.Name} />
                                                                    </ListItemButton>
                                                                </ListItem>
                                                            );
                                                        })}
                                                </List>
                                            :
                                            null



                                    }

                                </div>
                            )
                        })
                    }


                </div>

            </Modal.Body>


        </Modal >
    )
}

export default ShowMoreEventsModal